import { render, staticRenderFns } from "./TopLevelMenu.vue?vue&type=template&id=b4fbc134&scoped=true"
import script from "./TopLevelMenu.vue?vue&type=script&lang=js"
export * from "./TopLevelMenu.vue?vue&type=script&lang=js"
import style0 from "./TopLevelMenu.vue?vue&type=style&index=0&id=b4fbc134&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fbc134",
  null
  
)

export default component.exports